<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link to="/discount">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to Discounts </span>
			</router-link>
		</div>
		<base-page-heading
			title="Discount Edit"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateDiscountEditProperties"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<DiscountEditTable
				ref="editdiscountedit"
				:discount-edit-id="$route.params.id"
			/>
		</div>
	</div>
</template>

<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
